export const optionsSourceFrom = [
    { value: 1, label: 'FB Cent' },
    { value: 8, label: 'SP Premium' },
    { value: 9, label: 'FB Triệt lông' },
    { value: 2, label: 'IG Cent' },
    { value: 3, label: 'Giới Thiệu' },
    { value: 4, label: 'Website' },
    { value: 5, label: 'Zalo' },
    { value: 6, label: 'Hotline' },
    { value: 7, label: 'TikTok' },
  ]

  export const optionsSourceFromSelect = [
    { value: 0, label: 'Tất cả' },
    { value: 1, label: 'FB Cent' },
    { value: 8, label: 'Cent Premium' },
    { value: 9, label: 'FB Triệt lông' },
    { value: 2, label: 'IG Cent' },
    { value: 3, label: 'Giới Thiệu' },
    { value: 4, label: 'Website' },
    { value: 5, label: 'Zalo' },
    { value: 6, label: 'Hotline' },
    { value: 7, label: 'TikTok' },
  ]

  export const hourSelect = [
    { value: 0, label: '0 giờ' },
    { value: 1, label: '1 giờ' },
    { value: 2, label: '2 giờ' },
    { value: 3, label: '3 giờ' },
    { value: 4, label: '4 giờ' },
    { value: 5, label: '5 giờ' },
    { value: 6, label: '6 giờ' },
    { value: 7, label: '7 giờ' },
    { value: 8, label: '8 giờ' },
    { value: 9, label: '9 giờ' },
    { value: 10, label: '10 giờ' },
    { value: 11, label: '11 giờ' },
    { value: 12, label: '12 giờ' },
    { value: 13, label: '13 giờ' },
    { value: 14, label: '14 giờ' },
    { value: 15, label: '15 giờ' },
    { value: 16, label: '16 giờ' },
    { value: 17, label: '17 giờ' },
    { value: 18, label: '18 giờ' },
    { value: 19, label: '19 giờ' },
    { value: 20, label: '20 giờ' },
    { value: 21, label: '21 giờ' },
    { value: 22, label: '22 giờ' },
    { value: 23, label: '23 giờ' },
  ]

  export const minuteSelect = [
    {value: 'All', label: 'Tất cả' },
    { value: 0, label: '0' },
    { value: 5, label: '5' },
    { value: 10, label: '10' },
    { value: 15, label: '15' },
    { value: 20, label: '20' },
    { value: 25, label: '25' },
    { value: 30, label: '30' },
    { value: 35, label: '35' },
    { value: 40, label: '40' },
    { value: 45, label: '45' },
    { value: 50, label: '50' },
    { value: 55, label: '55' },
   
  ]

  export const optionsSourceFromShow = {
    1: 'FB Cent',
    8: 'SP Premium',
    9: "FB Triệt lông",
    2: 'IG Cent',
    3: 'Giới Thiệu',
    4: 'Website',
    5: 'Zalo',
    6: 'Hotline',
    7: 'TikTok',
  }

  export const optionsProvinceAll = [
    { value: 1, label: 'Hà Nội' },
    { value: 2, label: 'Cao Bằng' },
    { value: 3, label: 'Tuyên Quang' },
    { value: 4, label: 'Điện Biên' },
    { value: 5, label: 'Lai Châu' },
    { value: 6, label: 'Sơn La' },
    { value: 7, label: 'Lào Cai' },
    { value: 8, label: 'Thái Nguyên' },
    { value: 9, label: 'Lạng Sơn' },
    { value: 10, label: 'Quảng Ninh' },
    { value: 11, label: 'Bắc Ninh' },
    { value: 12, label: 'Phú Thọ' },
    { value: 13, label: 'Hải Phòng' },
    { value: 14, label: 'Hưng Yên' },
    { value: 15, label: 'Ninh Bình' },
    { value: 16, label: 'Thanh Hóa' },
    { value: 17, label: 'Nghệ An' },
    { value: 18, label: 'Hà Tĩnh' },
    { value: 19, label: 'Quảng Trị' },
    { value: 20, label: 'Huế' },
    { value: 21, label: 'Đà Nẵng' },
    { value: 22, label: 'Quảng Ngãi' },
    { value: 23, label: 'Gia Lai' },
    { value: 24, label: 'Khánh Hòa' },
    { value: 25, label: 'Đắk Lắk' },
    { value: 26, label: 'Lâm Đồng' },
    { value: 27, label: 'Đồng Nai' },
    { value: 28, label: 'TP. Hồ Chí Minh' },
    { value: 29, label: 'Tây Ninh' },
    { value: 30, label: 'Đồng Tháp' },
    { value: 31, label: 'Vĩnh Long' },
    { value: 32, label: 'An Giang' },
    { value: 33, label: 'Cần Thơ' },
    { value: 34, label: 'Cà Mau' },
  ]

  // Tạm thời chỉ mở Hà Nội và TP. Hồ Chí Minh, các tỉnh còn lại ẩn
  const provinceEnabled = [1, 28]

  export const optionsProvince = optionsProvinceAll.filter(item => provinceEnabled.includes(item.value))

  export const optionsProvinceShow = optionsProvinceAll.reduce((acc, item) => {
    acc[item.value] = item.label
    return acc
  }, {})

  export const optionsProvinceSelect = [
    { value: 0, label: 'Tất cả' },
    ...optionsProvince,
  ]

  export const status = [
    {value: "", label: 'Tất cả' },
    {value: 'Mess', label: 'Mess' },
    {value: 'Lead', label: 'Lead' },
    {value: 'Pre order', label: 'Pre order' },
    {value: 'CSKH', label: 'CSKH' },
    {value: 'Khác', label: 'Khác' },
    {value: 'Không đến', label: 'Không đến' },
  ]

  export const editStatus = [
    {value: 'Mess', label: 'Mess' },
    {value: 'Lead', label: 'Lead' },
    {value: 'CSKH', label: 'CSKH' },
    {value: 'Khác', label: 'Khác' },
    {value: 'Không đến', label: 'Không đến' },
  ]

  export const customStylesFilterOption = {
    option: (provided, state) => ({
      ...provided,
      padding: 10,
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      display: "none",
    }),
    control: (provided, state) => ({
      ...provided,
      width: 120,
      textAlign: "center",
      minHeight: 32,
    }),
    singleValue: (provided, state) => {
      const opacity = state.isDisabled ? 0.5 : 1;
      const transition = "opacity 300ms";
      return { ...provided, opacity, transition };
    },
  }